import React from 'react';
import { useNotification } from '../../../../utils/NotificationContext';
import NotificationItem from './NotificationItem';
import './Notification.css';

const NotificationContainer = () => {
    const { notifications } = useNotification();

    return (
        <div className="notification-container">
            {notifications.map(notification => (
                <NotificationItem key={notification.id} notification={notification} />
            ))}
        </div>
    );
};

export default NotificationContainer;
